import { Component, ChangeDetectionStrategy, input } from '@angular/core';

export interface AiStats {
  latencyMs?: number;
  totalTokens?: number;
  retrievedChunks?: number;
  mode?: string;
}

@Component({
  selector: 'app-ai-stats-row',
  templateUrl: './ai-stats-row.component.html',
  styleUrls: ['./ai-stats-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AiStatsRowComponent {
  stats = input.required<AiStats>({ alias: 'stats' });

  // Only 'chat'/'query' (ChatAiConfig.mode) are known - anything else (a future mode, or a
  // history item whose `type` doesn't match) falls back to showing the raw value rather than
  // hiding the stat entirely.
  modeLabelKey(): string {
    switch (this.stats().mode) {
      case 'chat':
        return 'cl_chat.aiStatsModeChat';
      case 'query':
        return 'cl_chat.aiStatsModeQuery';
      default:
        return '';
    }
  }
}
